import {
  DefaultCustomerConfiguration as ApiDefaultCustomerConfiguration,
  DefaultCustomerConfigurationInterface,
  RetailConfiguration as ApiRetailConfiguration,
} from '@vendasta/billing';
import { CollectionMethod, collectionMethodFromApi, collectionMethodToApi } from '../retail-customer-configuration';

export interface RetailConfiguration {
  merchantId: string;
  retailGroupId: string;
  currencyCode: string;
  currencyConversionRate: number;
  defaultCustomerConfiguration?: DefaultCustomerConfiguration;
}

export interface DefaultCustomerConfiguration {
  generateMethod: GenerateMethod;
  collectionMethod: CollectionMethod;
  invoiceDay: number;
  netD: number;
  memo: string;
  autoGenerateRetailSubscriptions: boolean;
}

export enum GenerateMethod {
  UNSET = 'Unset',
  SUBSCRIPTION = 'Subscription',
  TEMPLATE = 'Template',
}

export function generateMethodToApi(m: GenerateMethod | undefined): string {
  switch (m) {
    case GenerateMethod.SUBSCRIPTION:
      return 'subscription';
    case GenerateMethod.TEMPLATE:
      return 'template';
    default:
      return '';
  }
}

export function generateMethodFromApi(m: string): GenerateMethod {
  switch (m) {
    case 'subscription':
      return GenerateMethod.SUBSCRIPTION;
    case 'template':
      return GenerateMethod.TEMPLATE;
    default:
      return GenerateMethod.UNSET;
  }
}

export function retailConfigurationFromApi(proto: ApiRetailConfiguration): RetailConfiguration {
  return {
    merchantId: proto.merchantId,
    retailGroupId: proto.retailGroupId,
    currencyCode: proto.currencyCode,
    currencyConversionRate: proto.currencyConversionRate || 0,
    defaultCustomerConfiguration: defaultCustomerConfigurationFromApi(proto.defaultCustomerConfiguration),
  };
}

export function defaultCustomerConfigurationFromApi(
  proto: ApiDefaultCustomerConfiguration,
): DefaultCustomerConfiguration | undefined {
  if (!proto) {
    return undefined;
  }
  const collectionMethod = collectionMethodFromApi(proto.collectionMethod);
  return {
    generateMethod: generateMethodFromApi(proto.generateMethod),
    collectionMethod: collectionMethod,
    invoiceDay: proto.invoiceDay,
    netD: proto.netD,
    memo: proto.memo,
    autoGenerateRetailSubscriptions: proto.autoGenerateRetailSubscriptions ?? false,
  };
}

export function defaultCustomerConfigurationToApi(
  c: DefaultCustomerConfiguration | undefined,
): DefaultCustomerConfigurationInterface | undefined {
  if (!c) {
    return undefined;
  }
  return {
    generateMethod: generateMethodToApi(c.generateMethod),
    collectionMethod: collectionMethodToApi(c.collectionMethod),
    invoiceDay: c.invoiceDay,
    netD: c.netD,
    memo: c.memo,
    autoGenerateRetailSubscriptions: c.autoGenerateRetailSubscriptions ?? false,
  } as ApiDefaultCustomerConfiguration;
}
